// Read access string contants
var READ_ACCESS = {
    FULL_DETAILS: 'FullDetails',
    NONE: 'None',
};
// Edit/delete access string contants
var EDIT_ACCESS = {
    ALL: 'All',
    NONE: 'None',
    OWNED: 'Owned',
};
// Permission level string contants
var PERMISSION_LEVEL_TYPE = {
    OWNER: 'Owner',
    PUBLISHING_EDITOR: 'PublishingEditor',
    EDITOR: 'Editor',
    PUBLISHING_AUTHOR: 'PublishingAuthor',
    AUTHOR: 'Author',
    NONEDITING_AUTHOR: 'NoneditingAuthor',
    REVIEWER: 'Reviewer',
    CONTRIBUTOR: 'Contributor',
    NONE: 'None',
    CUSTOM: 'Custom',
};
// Pemrission properties string contants
var PROPERTY = {
    CAN_CREATE_ITEMS: 'CanCreateItems',
    CAN_CREATE_SUB_FOLDERS: 'CanCreateSubFolders',
    DELETE_ITEMS: 'DeleteItems',
    EDIT_ITEMS: 'EditItems',
    IS_FOLDER_CONTACT: 'IsFolderContact',
    IS_FOLDER_OWNER: 'IsFolderOwner',
    IS_FOLDER_VISIBLE: 'IsFolderVisible',
    READ_ITEMS: 'ReadItems',
    PERMISSION_LEVEL: 'PermissionLevel',
};
export default {
    PROPERTY: PROPERTY,
    EDIT_ACCESS: EDIT_ACCESS,
    READ_ACCESS: READ_ACCESS,
    PERMISSION_LEVEL_TYPE: PERMISSION_LEVEL_TYPE,
};
//# sourceMappingURL=permissionConstants.js.map